// 관리자 첫 화면 알림 — 사장님 휴대폰·보호자 문의 번호가 비어 있으면 환경 설정에서 넣으라고 알린다(막지는 않는다, 대표 결정 Q3·Q4)
import { Link } from "react-router-dom";
import { useOrgStore } from "@/store/org";
import DpaConsentCard from "@/components/DpaConsentCard";

export default function OrgContactMissing() {
  const org = useOrgStore((s) => s.org);
  if (!org) return null;
  // 처리위탁 동의 카드도 여기서 함께 띄운다 — AdminHome은 다른 묶음이 고치는 중이라 그 파일을 건드리지 않으려고(합친 뒤 AdminHome으로 옮겨도 된다)
  return (
    <>
      <DpaConsentCard />
      <ContactMissing />
    </>
  );
}

function ContactMissing() {
  const org = useOrgStore((s) => s.org);
  if (!org) return null;
  const missing = [
    !org.ownerPhone && "사장님 휴대폰(청구 문자·긴급 연락·기사님 연락)",
    !org.guardianContactPhone && "보호자 문의 번호(보호자 사진 화면·문자에 보임)",
  ].filter(Boolean) as string[];
  if (!missing.length) return null;
  return (
    <Link to="/admin/org" className="block card p-4 border border-amber-300 bg-amber-50 hover:bg-amber-100 transition">
      <div className="font-bold text-amber-800">📞 업체 연락처를 넣어 주세요 — {missing.join(", ")}</div>
      <div className="text-xs text-amber-700 mt-1">비어 있으면 청구 문자를 못 받고 보호자가 업체에 연락할 번호를 모릅니다. 눌러서 환경 설정으로 이동 →</div>
    </Link>
  );
}
